import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        await api.post("/auth/google/session", { session_id: sessionId });
        window.history.replaceState({}, "", "/app/dashboard");
        await checkAuth();
        navigate("/app/dashboard", { replace: true });
      } catch (e) {
        setError("Google sign-in could not be completed. Please try again.");
      }
    })();
  }, [location.hash, navigate, checkAuth]);

  return (
    <div data-testid="auth-callback" className="flex min-h-screen items-center justify-center bg-elv-base">
      {error ? (
        <div className="glass max-w-sm rounded-lg p-6 text-center">
          <p className="text-sm text-red-300">{error}</p>
          <button
            type="button"
            data-testid="auth-callback-retry"
            onClick={() => navigate("/login", { replace: true })}
            className="mt-5 rounded-md bg-elv-green px-4 py-2 text-xs font-semibold text-[#04120A]"
          >
            Back to sign in
          </button>
        </div>
      ) : (
        <Loader2 className="h-5 w-5 animate-spin text-elv-green" />
      )}
    </div>
  );
}
